/**
 * Created by Bob.Bao on 2017/12/18.
 */
import apis from '../apis'
import * as types from '../mutation-types'

const state = {
    form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
    }
}
const getters = {
    getForm: state => state.form
}

const actions = {
    submitForm({ commit, state }){
        apis.submitForm(state.form, form => {
            commit(types.PAGE_FORM, form)
        }, err => {
            alert(err)
        })
    }
}

const mutations = {
    [types.PAGE_FORM] (state,  payload ) {
        console.log(payload)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/form.js